import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const GalleryById = async (id) => {
  try {
    return await getData(`/website/gallery/gallery/${id}`);
  } catch (error) {
    console.log(error);
  }
};


export const Gallerys = async () => {
  try {
    return await getData(`/website/gallery/gallery`);
  } catch (error) {
    console.log(error);
  }
};